import m from "../../geodata/es2015/anguillaHigh";
window.am4geodata_anguillaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/anguillaHigh.js
// module id = null
// module chunks = 